<template>
  <v-card
    :style="{ 'background-color': 'rgb(0,0,0,0.1)' }"
    dark
    min-height="400"
  >
    <v-card-text>
      <v-form>
        <v-text-field
          label="Name"
          name="name"
          prepend-icon="person"
          type="text"
          v-model="name"
        />

        <v-text-field
          label="Email"
          name="email"
          prepend-icon="email"
          type="text"
          v-model="email"
        />

        <v-text-field
          label="Tel #"
          name="tel"
          prepend-icon="phone_callback"
          type="text"
          v-model="tel"
        />

        <v-text-field
          id="password"
          label="Password"
          name="password"
          prepend-icon="lock"
          type="password"
          v-model="password"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn class="ml-10" outlined dark @click.prevent="register" rounded
        >Submit</v-btn
      >
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "@/plugins/axios";
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["getThemeColor", "getUserCompany", "getAccessToken"]),

  mounted() {
    if (
      this.$route.query.token != undefined &&
      this.$route.query.token != null
    ) {
      this.token = this.$route.query.token;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-invited-user",
          { token: this.token },
          this.getAccessToken
        )
        .then((invitedUser) => {
          this.$store.commit("setLoader", false);
          this.name = invitedUser.name;
          this.email = invitedUser.email;
          this.tel = invitedUser.phone;
          this.alevel = invitedUser.alevel;
          this.emis = invitedUser.emis;
        });
    }
  },
  data() {
    return {
      emis: null,
      alevel: null,
      token: null,
      name: null,
      email: null,
      tel: null,
      password: null,
    };
  },

  methods: {
    register() {
      if (
        this.name == null ||
        this.email == null ||
        this.tel == null ||
        this.password == null
      ) {
        alert("All Fields Are Required!");
      } else {
        let axiosPromise = "";
        if (this.token != null) {
          axiosPromise = axios.postData("/auth/register-invited-user", {
            name: this.name,
            alevel: this.alevel,
            token: this.token,
            email: this.email,
            tel: this.tel,
            password: this.password,
            emis: this.emis,
          });
        } else {
          axiosPromise = axios.postData("/auth/register", {
            name: this.name,
            email: this.email,
            tel: this.tel,
            password: this.password,
            emis: this.getUserCompany.emis,
          });
        }
        axiosPromise.then(() => {
          this.login();
        });
      }
    }, //end of login method
    login() {
      axios
        .postData("/auth/login", {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          if (response.status != 401) {
            this.snackbar = true;
            this.$store.commit("setAccessToken", response.token);
            this.$store.commit("setCurrentUser", response.user);
            this.$store.commit("setAuthenticated", true);

            // const socket = io(this.getEndPoint);
            // this.$store.commit("setSocket", socket);

            localStorage.setItem("token", response.token);
            localStorage.setItem("authenticated", true);

            this.$router.push({ name: "switchboard" });
          } else {
            this.snackbar = true;
            this.loginMsg = response.data.error;
          }
        });
    }, //end of login method
  },
};
</script>
